import React from 'react';
import styles from "./MobileComponents.module.css";
import HiviewerLoader from '../../../../components/shared/HiviewerLoader';

interface IProps {
  ready: boolean
}

const MobileCover = ({ ready }: IProps) => {
  if (ready) return null;

  return (
            <div className={styles.cover} aria-hidden="true">
      <div className={styles.loaderBg}>
        <HiviewerLoader />
      </div>
    </div>
  );
};

export default MobileCover;
